import React from 'react';
import { withErrorBoundary } from '@nile/components';
import { Modal } from '@superops/ui-design-system';
import DataReportContainer from '@nile/reports/src/modules/DataReports/components/subpages/DataReportContainer';

const DataReportCascade = (props) => {
  const { callBack, mode, report = null, source = 'datareport' } = props;

  const handleChange = () => {
    if (callBack) {
      callBack(false);
    }
  };

  return (
    <Modal open onClose={handleChange} showCloseButton={false} fullScreen>
      <div className="vh100-80">
        <DataReportContainer
          mode={mode}
          reportId={report && report.reportId}
          source={source}
          closeModal={handleChange}
        />
      </div>
    </Modal>
  );
};

export default withErrorBoundary(DataReportCascade);
